function menu(){

    const menuTrig = document.querySelector('.menu-trig');

    if(menuTrig){
        
        menuTrig.addEventListener('click', function(){
        
            document.body.classList.toggle('menu-open');
            
            for (let a = 0; a <  window.animations.length; a++) {
                const animation = window.animations[a];
                animation.setSpeed(Math.floor(Math.random() * 5) + 2);
                animation.playSegments([0, 25], true);
                
            }

        });


        cal_filter();
        bind_links();
    }
}

function bind_links(){

    let menu = document.querySelector('.menu');
    let links = menu.querySelectorAll('a');

    for (let a = 0; a < links.length; a++) {
        const elm = links[a];

        elm.addEventListener('click', function(e){

            if(elm.classList.contains('active')){
                e.preventDefault();
                document.body.classList.remove('menu-open');

                for (let a = 0; a <  window.animations.length; a++) {
                    const animation = window.animations[a];
                    animation.setSpeed(Math.floor(Math.random() * 5) + 2);
                    animation.playSegments([0, 25], true);
                }
            }

        });
        
    }

   
}

function cal_filter(){

    let avlDays = document.querySelectorAll('.day.available');

    
    for (let a = 0; a < avlDays.length; a++) {
        const elm = avlDays[a];

        elm.addEventListener('click',function(e){
            e.preventDefault();

            if(!this.classList.contains('today')){
                document.querySelector('.today').classList.remove('today');
                elm.classList.add('today');

                var date = elm.dataset.date;

                let list = document.querySelector('.list');
                let elms = Array.from(list.querySelectorAll(`[data-date="${date}"]`));
                let links = list.querySelectorAll(`a`);
                let lastmove = list.firstChild;

                for (let b = 0; b < links.length; b++) {
                    const link = links[b];     
                    
                    if(elms.includes(link)){
                        link.classList.remove('visible');
                        list.insertBefore(link, lastmove);
                        lastmove = link.nextSibling;
                        link.classList.add('visible');
                    }else{
                        link.classList.remove('visible');
                    }
                }

                elm.classList.add('shiver');
                setTimeout(function(){
                    elm.classList.remove('shiver');
                }, 600);
            }else{
                elm.classList.add('shiver');
                setTimeout(function(){
                    elm.classList.remove('shiver');
                }, 600);
            }


        });
        
    }
}


export default menu;